import { colours } from "@shared/ui.design-system";
import React from "react";

import { Rating } from "../../Rating/Rating";

import {
  emptyHorizontalProductCardRating,
  horizontalProductCardRating
} from "./HorizontalProductCard.css";
import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "rating" | "reviewCount">;
};

export const HorizontalProductCardRating: React.FC<Props> = ({ product }) => {
  if (!product.rating)
    return <div className={emptyHorizontalProductCardRating} />;

  return (
    <div className={horizontalProductCardRating}>
      <Rating
        totalReviews={product.reviewCount}
        ratingValue={product.rating}
        renderCountAsLink={false}
        activeColor={colours.accent.strong}
        numberOfStars={1}
      />
    </div>
  );
};
